<template>
  <div class="evaluate-container">
    <p class="evaluate-title">
      <img :src="notice" alt="通知">
      <span>同学，您好！请您对本次面谈进行评价：</span>
    </p>
    <ul class="evaluate-list">
      <li v-for="(item,index) in evaluateList" :key="index" @click="selectClickFun(item)">
        <img :src="current == item.name ?item.selected:item.url">
        <span>{{item.name}}</span>
      </li>
    </ul>
    <div class="evaluate-text" v-if="current=='不满意' || current=='非常不满意'">
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="contactFeedback"
        maxlength="200"
        :disabled="evaluateModel.contactEvaluate"
        show-word-limit>
      </el-input>
    </div>
    <div class="evaluate-footer" :class="current==='不满意' || current==='非常不满意'?'evaluate-not-footer':''">
      <button :class="(current!='' && !evaluateModel.contactEvaluate)?'active':''" @click="evaluateSubmitFun">{{evaluateModel.contactEvaluate?'已评价':'立即评价'}}</button>
    </div>
  </div>
</template>

<script>
  import notice from '@/assets/evaluate/notice.png'
  import verySatisfied from '@/assets/evaluate/very-satisfied.png'
  import satisfied from '@/assets/evaluate/satisfied.png'
  import commonly from '@/assets/evaluate/commonly.png'
  import dissatisfied from '@/assets/evaluate/dissatisfied.png'
  import extremelyDissatisfied from '@/assets/evaluate/extremely-dissatisfied.png'
  import verySatisfiedActive from '@/assets/evaluate/very-satisfied-active.png'
  import satisfiedActive from '@/assets/evaluate/satisfied-active.png'
  import commonlyActive from '@/assets/evaluate/commonly-active.png'
  import dissatisfiedActive from '@/assets/evaluate/dissatisfied-active.png'
  import extremelyDissatisfiedActive from '@/assets/evaluate/extremely-dissatisfied-active.png'
  import Common from '@/utils/common'
  import customerService from '@/api/customerService'

  export default {
    name: "evaluate",
    data: function () {
      return{
        notice,
        verySatisfied,
        satisfied,
        commonly,
        dissatisfied,
        extremelyDissatisfied,
        verySatisfiedActive,
        satisfiedActive,
        commonlyActive,
        dissatisfiedActive,
        extremelyDissatisfiedActive,
        evaluateList:[
          {name:'非常满意',url:verySatisfied,selected:verySatisfiedActive},
          {name:'满意',url:satisfied,selected:satisfiedActive},
          {name:'一般',url:commonly,selected:commonlyActive},
          {name:'不满意',url:dissatisfied,selected:dissatisfiedActive},
          {name:'非常不满意',url:extremelyDissatisfied,selected:extremelyDissatisfiedActive}],
        current:'',
        contactFeedback:'',
        trackId:'',
        mobile:'',
        evaluateModel:{}
      }
    },
    mounted() {
      var vm = this;
      vm.trackId = vm.$route.query.trackId;
      vm.mobile = vm.$route.query.mobile;
      document.title = '面谈评价';
      vm.getEvaluateDetail();
    },
    methods:{
      selectClickFun:function(item){
        var vm = this;
        if(item.name == vm.current){
          return;
        }
        if(!Common.Util.isEmpty(vm.evaluateModel.contactEvaluate)){
          return;
        }
        vm.current = item.name;
      },
      getEvaluateDetail:function(){
        var vm = this;
        customerService.checkMobile(vm, vm.trackId, vm.mobile).then(function (data) {
          vm.evaluateModel = data;
          if(data && data.contactEvaluate){
            vm.current = data.contactEvaluate;
          }
          if(data && data.contactFeedback){
            vm.contactFeedback = data.contactFeedback;
          }
        });
      },
      evaluateSubmitFun:function(){
        var vm = this;
        if(!Common.Util.isEmpty(vm.evaluateModel.contactEvaluate)){
          return;
        }
        if(Common.Util.isEmpty(vm.current)){
          return;
        }
        //trackId,contactEvaluate,contactFeedback
        customerService.saveEvaluate(vm,vm.trackId,vm.current,vm.contactFeedback).then(function(data){
          vm.$router.push({path: '/evaluateResult', query: {}});
        });
      },
    }
  }
</script>

<style scoped>
  .evaluate-container {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background:#F9F9F9;
    position:relative;
  }
  .evaluate-title{
    width:100%;
    height: 40px;
    background: linear-gradient(217deg, #FFCC66 0%, #FF9D36 100%);
    box-shadow: 0 5px 6px 0 rgba(0,0,0,0.06);
    margin-bottom:30px;
    color:#fff;
    padding-left: 5px;
  }
  .evaluate-title>img{
    width:38px;
    vertical-align: middle;
  }
  .evaluate-title>span{
    position: relative;
    top: 1px;
  }
  .evaluate-list{
    margin:10px;
    width:calc(100% - 20px);
    display:flex;
    align-items: center;
    background:#fff;
    justify-content: space-between;
    padding:20px 10px;
  }
  .evaluate-list>li{
      display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .evaluate-list>li>img{
    width:35px;
  }
  .evaluate-list>li>span{
    display: block;
    text-align: center;
    font-size: 12px;
    padding-top: 10px;
  }
  .evaluate-list>li:last-child{
    margin-right:0
  }
  .evaluate-footer{
    width: 100%;
    text-align: center;
    padding-top:50px;
  }
  .evaluate-not-footer{
    padding-top:50px;
  }
  .evaluate-footer>button{
    width: 95%;
    background: #F5F2F5;
    border: none;
    color: #666;
    font-size: 16px;
    height: 47px;
  }
  .evaluate-footer>button.active{
    width: 95%;
    background: #D43D3D;
    color: #fff;
    box-shadow: 0 5px 6px 0 rgba(212, 61, 61, 0.6);
    border: none;
    border-radius: 3px;
  }
  .evaluate-text{
    margin:10px;
    background:#fff;
    padding:10px;
  }
  .evaluate-text .el-textarea__inner{
    height:100px;
  }
</style>



// WEBPACK FOOTER //
// src/views/evaluate.vue